import { scaleByPowerOfTen } from '@/shared/utils/decimal-scale/decimal-scale.util';

/**
 * The stored 0–1 fraction, as the 0–100 the operator thinks in.
 *
 * Through `scaleByPowerOfTen` rather than `* 100`, because the multiplication
 * carries the error the binary literal already had: `0.07 * 100` is
 * `7.000000000000001`, and a confidence threshold that reads like that has told
 * the operator their setting is not the number they saved.
 */
export function toPercent(fraction: number | null | undefined): number | undefined {
  if (fraction === null || fraction === undefined) return undefined;
  return scaleByPowerOfTen(fraction, 2);
}

/** The 0–100 the operator typed, as the 0–1 fraction the setting stores. */
export function toFraction(percent: number | null | undefined): number | undefined {
  if (percent === null || percent === undefined) return undefined;
  return scaleByPowerOfTen(percent, -2);
}
